import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import * as Colors from 'ui-library/Colors';
import FieldLabel from 'ui-library/inputs/FieldLabel';

// TODO: Move to ui-library once we add back the checkbox

export default function SelectableCard({
  children,
  onChange,
  selected,
  title,
}: {
  children: ReactNode;
  onChange: (value: boolean) => void;
  selected: boolean;
  title: JSX.Element | string;
}): JSX.Element {
  return (
    <div className={css(styles.card, selected && styles.cardSelected)}>
      <div className={css(styles.cardHeader)}>
        {/* Put this back when we make these cards selectable */}
        {/* <Checkbox
          checked={selected}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
        /> */}
        <FieldLabel className={css(styles.title)} label={title} />
      </div>
      <div className={css(styles.cardBody)}>{children}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  card: {
    border: `1px solid ${Colors.GRAY_LIGHT}`,
    borderRadius: 4,
    padding: 8,
    marginBottom: 4,
    ':hover': {
      borderColor: Colors.GRAY,
      boxShadow: `0px 2px 6px 1px ${Colors.SILVER}`,
    },
  },
  cardSelected: {
    background: Colors.BLUE_POWDER_LIGHT,
    border: `1px solid ${Colors.BLUE}`,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  cardBody: {
    marginLeft: 22,
  },
  title: {
    marginLeft: 6,
    wordBreak: 'break-word',
  },
});
